define.alias("ember-power-select/components/power-select/search-message", "calendar/components/power-select/search-message");